module.exports = __webpack_public_path__ + "media/images/realty-one-group-color-large-8e070480.png";